import classNames from 'classnames';
import { useEffect } from 'react';
import * as React from 'react';
import { useDropzone } from 'react-dropzone';

interface DropzoneProps {
  onOpen: (acceptedFiles: File[]) => void;
  isLoading: boolean;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openFile?: () => void;
}

const Dropzone = ({
  onOpen,
  isLoading,
  isOpen,
  setIsOpen,
  openFile,
}: DropzoneProps) => {
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept: {
      'application/csv': ['.csv'],
    },
    maxSize: 25 * 1024 * 1024,
    onDrop: async (acceptedFiles) => {
      onOpen(acceptedFiles);
    },
  });

  useEffect(() => {
    if (isOpen) {
      openFile ? openFile() : open();
      setIsOpen(false);
    }
  }, [isOpen]);

  return (
    <div
      {...getRootProps({ className: 'dropzone' })}
      className={classNames(
        'w-full h-full flex flex-col items-center justify-between p-10 font-sans',
        {
          'bg-gray-100': isDragActive,
          'bg-white': !isDragActive,
        },
      )}
    >
      <input data-test-id='dnd-input' {...getInputProps()} />

      <div className='text-black font-medium'>
        {isLoading ? <p>In Progress</p> : <p>Drag and drop your csv</p>}
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <p className='text-sm font-normal underline cursor-pointer'>
          or click here to upload
        </p>
      )}
    </div>
  );
};

export default Dropzone;
